import { useQuery } from "@tanstack/react-query";
import { useCompanyAxis } from "@/api/use-company-context";
import { useSessionScope } from "@/auth/use-session-scope";
import { authority } from "./api";

export type FormAuthority = Awaited<ReturnType<typeof authority>>;
export const canOpenFormManagement = (value: FormAuthority | undefined): boolean => value?.can_manage === true;

export function useFormAuthority({ manage = true, enabled = true }: { manage?: boolean; enabled?: boolean } = {}) {
  const scope = useSessionScope();
  const company = useCompanyAxis();
  const legalEntityId = manage ? company.active_legal_entity_id : null;
  return useQuery({
    queryKey: ["forms-authority", ...scope, legalEntityId],
    queryFn: () => authority(legalEntityId ?? undefined),
    enabled,
    staleTime: 60_000,
  });
}
